import { ITeamMemberPermissionState } from '../../../types'
import { ITeamMemberPermissionAction } from '../../actions/team-member-permission'
import * as constants from '../../constants'

const initTeamMemberPermissionState: ITeamMemberPermissionState = {
  currentPermission: null,
  permission: null,
  isFetching: false,
  error: ''
}

export function teamMemberPermission(state: ITeamMemberPermissionState, action: ITeamMemberPermissionAction) {
  if (typeof state === 'undefined') {
    return initTeamMemberPermissionState
  }

  switch (action.type) {
    case constants.TEAM_MEMBER_PERMISSION_FETCH_REQUEST:
    case constants.TEAM_MEMBER_PERMISSION_CREATE_REQUEST:
    case constants.TEAM_MEMBER_PERMISSION_UPDATE_REQUEST:
      return { ...state, isFetching: true, permission: null }
    case constants.TEAM_MEMBER_PERMISSION_CREATE_SUCCESS:
    case constants.TEAM_MEMBER_PERMISSION_FETCH_SUCCESS:
      return { ...state, isFetching: false, permission: action.payload }
    case constants.TEAM_MEMBER_PERMISSION_FETCH_FAIL:
    case constants.TEAM_MEMBER_PERMISSION_CREATE_FAIL:
    case constants.TEAM_MEMBER_PERMISSION_UPDATE_FAIL:
      return { ...state, error: action.payload, permission: null, isFetching: false }
    case constants.SET_CURRENT_TEAM_MEMBER_PERMISSION:
      return { ...state, currentPermission: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/team-member-permission/index.ts